/**
 * src/lib/canonical.js
 *
 * Canonical site origin for SEO surfaces (JSON-LD schemas, OG `url:`
 * meta tags, sitemap absolute URLs).
 *
 * Hard-coded to the production hostname so schemas remain stable across
 * environments — `window.location.origin` would otherwise emit
 * `.preview.emergentagent.com` or `.emergent.host` URLs while we're on
 * deploy targets, breaking Google's Knowledge Graph linkage on rollback
 * or domain switch.
 */

export const SITE_ORIGIN = 'https://mobilecorex.ng';

/**
 * Build an absolute URL for a given pathname.
 * Accepts either a leading-slash path ('/foo') or a relative one ('foo').
 */
export function canonicalUrl(path = '') {
  if (!path) return SITE_ORIGIN;
  return path.startsWith('/') ? `${SITE_ORIGIN}${path}` : `${SITE_ORIGIN}/${path}`;
}
